export const StoreState = {
  loginSelected: 'loginSelected'
};

export default {
  loginSelected: false
};
